import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
let isMounted = false;


const styles = (theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
});
const sendProps = (props) => {
    const { classes, ...rest } = props;
    return rest;
};
class CreditsListScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            transaction: 0,
            earnings_data: [],
            transaction_details: [],
            earnings_total: 0,
            refer_details: [],
            refer_amount: 0,
            totalAmountCalculate: 0,
            totalAmount: 0
        };
    }
    componentDidMount() {
        // console.log('master key', this.state.categoryDataPrev.key);
        this.getCreditData()
        this.getReferData()
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    getCreditData = async () => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'get',
                url: `${SERVER_URL}/booking/get-user-credit`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('credit data new', data);
            if (data.status == 'OK') {
                this.setState({
                    transaction: data.data.total_amount,
                    // transaction: 0.225555
                    transaction_details: data.data.transaction_details
                })
            }
            else {
                this.setState({
                    transaction: 0
                })
            }
        } catch (error) {
            console.log("====================get credit ERRORRRRRR", error);
        }
    }

    getReferData = async () => {
        var authToken = getCookies();
        // var latitude = getLatitude();
        // var longitude = getLongitude();
        // console.log('latitude', latitude, 'longitude', longitude, );
        try {
            const { data } = await Axios({
                method: 'post',
                url: `${SERVER_URL}/refer/get-refer-amount`,
                headers: {
                    'x-auth-Token': authToken,
                },
            });
            console.log('refer data new', data);
            if (data.status == 'OK') {
                this.setState({
                    refer_amount: data.data.total_amount,
                    refer_details: data.data.refer_data
                })
            }
            else {
                this.setState({
                    refer_amount: 0
                })
            }
        } catch (error) {
            console.log("====================get refer ERRORRRRRR", error);
        }
    }

    sumAmount = (credit, refer) => {
        let totalCreditAmount = credit + refer
        // let totalCreditAmount = 18889.366564
        let roundUpValue = totalCreditAmount.toString()

        if (roundUpValue.includes('.')) {
            return Number(totalCreditAmount).toFixed(2)
        } else {
            return Number(totalCreditAmount)
        }
    }



    render() {
        var well = {
            boxShadow: "2px 1px 5px #ddd",
            backgroundColor: '#fff',
            padding: 10,
            marginBottom: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // textAlign: 'center',
            cursor: 'pointer',
            borderRadius: 5
        }

        var totalAmount = this.sumAmount(this.state.transaction, this.state.refer_amount);
        return (
            <div className="tz-2-com tz-2-main h4-padding" style={{}}>
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <NavbarNew 
                                title='Choose Service' 
                                goback={() => this.props.history.goBack(null)} 
                            /> */}
                            <div>
                                <p style={{
                                    fontSize: 20,
                                    color: 'black',
                                    textAlign: 'center',
                                    marginBottom: 50,
                                    // border: '1px solid #eee'
                                }}>Total Amount - ${totalAmount}</p>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    borderBottom: '1px solid #ddd'
                                }}>
                                    <p>Type</p>
                                    <p>Item</p>
                                    <p>Amount</p>
                                </div>
                                {
                                    this.state.transaction_details.map((transaction) => {
                                        return (
                                            <div
                                                key={transaction.id}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    borderBottom: '1px solid #ddd',
                                                    paddingTop: 10
                                                }}>
                                                <p>Refund</p>
                                                <p style={{ display: 'flex', alignSelf: 'flex-start', width: '12%' }}>{transaction.booking_details.booking_number}</p>
                                                <p style={{ display: 'flex', alignSelf: 'flex-start', width: '7%' }}>{Number(transaction.return_value).toFixed(2)}</p>
                                            </div>
                                        )
                                    })
                                }
                                {
                                    this.state.refer_details.map((refer) => {
                                        return (
                                            <div
                                                key={refer.id}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    borderBottom: '1px solid #ddd',
                                                    paddingTop: 10
                                                }}>
                                                <p>Referral</p>
                                                <p style={{ display: 'flex', alignSelf: 'flex-start', width: '12%' }}>{refer.refer_name}</p>
                                                <p style={{ display: 'flex', alignSelf: 'flex-start', width: '7%' }}>{Number(refer.refer_amount).toFixed(2)}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(CreditsListScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/CreditsListScreenNew.jsx